/**
 * Service for handling data operations like clearing, importing, exporting
 */

// Default empty data structure
export const EMPTY_FORM_DATA = {
  personalInfo: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    photo: '',
    linkedin: '',
    github: '',
    professionalTitle: '',
    enablePictureSpace: true,
  },
  professionalSummary: '',
  workExperiences: [],
  educations: [],
  skills: [],
  projects: [],
  certifications: [],
  awardsAndHonors: [],
  languages: [],
  volunteerExperiences: [],
  publications: [],
  references: [],
};

/**
 * Clears all resume data (form data and selected sections)
 * 
 * @param {Function} updateFormData - Function to update form data 
 * @param {Function} setSelectedSections - Function to update selected sections
 * @param {Object} options - Additional options
 * @param {boolean} options.showConfirmation - Whether to show a confirmation dialog
 * @param {Function} options.onComplete - Callback to run after clearing data
 * @returns {boolean} - Whether the data was cleared (false if user canceled)
 */
export const clearAllData = (
  updateFormData, 
  setSelectedSections, 
  { showConfirmation = false, onComplete = null } = {}
) => {
  // Show confirmation dialog if requested
  if (showConfirmation) {
    if (!window.confirm('Are you sure you want to clear all data? This cannot be undone.')) {
      return false;
    }
  }
  
  // Reset selected sections
  setSelectedSections([]);
  
  // Reset form data through context using the default structure
  updateFormData(null, EMPTY_FORM_DATA);
  
  // Run completion callback if provided
  if (onComplete && typeof onComplete === 'function') {
    onComplete();
  }
  
  return true;
};

// Export other data-related utility functions here in the future 